const HomeTestimonials = () => {
  return (
    <section className="py-32 px-6 relative overflow-hidden bg-gradient-to-br from-slate-100 via-gray-50 to-white dark:from-black dark:via-gray-900 dark:to-gray-800">
      <div className="absolute inset-0 opacity-20 dark:opacity-10">
        <div className="absolute top-1/4 right-1/4 w-80 h-80 bg-gradient-radial from-gray-200/30 via-transparent to-transparent" />
        <div className="absolute bottom-1/4 left-1/4 w-72 h-72 bg-gradient-radial from-slate-200/30 via-transparent to-transparent" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto">
        <div className="text-center mb-20">
          <p className="text-xs font-light tracking-[0.4em] uppercase text-gray-400 dark:text-gray-500 mb-6">Voices from the Atelier</p>
          <h2 className="text-4xl md:text-5xl font-thin mb-8 text-gray-900 dark:text-white leading-tight">
            <span className="italic font-extralight">Connoisseurs</span>
            <br />
            Speak
          </h2>
          <div className="w-24 h-px bg-gradient-to-r from-transparent via-gray-300 dark:via-gray-600 to-transparent mx-auto" />
        </div>

        <div className="grid md:grid-cols-3 gap-12">
          {[
            {
              quote: "A revelation in personal styling. Every suggestion feels curated specifically for my aesthetic vision.",
              attribution: "Creative Director, Milan",
            },
            {
              quote: "The intelligence behind each recommendation is remarkable. It understands not just trends, but personal narrative.",
              attribution: "Fashion Editor, New York",
            },
            {
              quote: "Finally, technology that enhances rather than replaces the artistry of personal style. Perfection.",
              attribution: "Style Consultant, Paris",
            },
          ].map(({ quote, attribution }, i) => (
            <div key={i} className="group relative">
              <div className="bg-white/60 dark:bg-gray-900/60 backdrop-blur-sm border border-gray-200/30 dark:border-gray-700/30 p-8 h-full transition-all duration-500 group-hover:bg-white/80 dark:group-hover:bg-gray-900/80 group-hover:shadow-lg">
                <blockquote className="text-base font-light text-gray-700 dark:text-gray-300 leading-relaxed tracking-wide mb-8 italic">"{quote}"</blockquote>
                <div className="border-t border-gray-200/50 dark:border-gray-700/50 pt-6">
                  <p className="text-xs font-light tracking-[0.2em] uppercase text-gray-400 dark:text-gray-500">{attribution}</p>
                </div>
                <div className="absolute top-0 left-0 w-0 group-hover:w-full h-px bg-gradient-to-r from-gray-300 to-transparent dark:from-gray-600 transition-all duration-700" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeTestimonials;
